import * as React from 'react';
import { usePopper } from 'react-popper';
import { handleMouseProxy } from '../../dom';
import { Layer } from '../Helper';
import { TooltipArrow } from './TooltipArrow';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const defaultModifiers = [{
  name: 'offset',
  options: {
    offset: [0, 7]
  }
}];
function TooltipContainer({
  visible = false,
  enabled = true,
  placement = 'auto',
  modifiers = defaultModifiers,
  id,
  renderReference,
  children,
  onShow,
  onHide
}) {
  const [referenceElement, setReferenceElement] = React.useState(null);
  const [popperElement, setPopperElement] = React.useState(null);
  const [arrowElement, setArrowElement] = React.useState(null);
  const {
    styles,
    attributes
  } = usePopper(referenceElement, popperElement, {
    placement,
    modifiers: [...modifiers, {
      name: 'arrow',
      options: {
        element: arrowElement
      }
    }]
  });
  const [state, setState] = React.useState({
    visible
  });
  React.useEffect(() => {
    if (state.visible && typeof onShow === 'function') {
      onShow();
    }
    if (!state.visible && typeof onHide === 'function') {
      onHide();
    }
  }, [state.visible, onShow, onHide]);
  const show = () => {
    if (!enabled || visible || state.visible) {
      return;
    }
    setState({
      visible: true
    });
  };
  const hide = () => {
    if (visible || !state.visible) {
      return;
    }
    setState({
      visible: false
    });
  };
  const handleMouseOver = handleMouseProxy('fromElement', show);
  const handleMouseOut = handleMouseProxy('toElement', hide);
  const handleFocus = () => {
    show();
  };
  const handleBlur = () => {
    hide();
  };
  const handleKeyDown = evt => {
    if (evt.key === 'Escape') {
      hide();
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderReference(mergeProps => ({
      'aria-describedby': id,
      innerRef: setReferenceElement,
      onMouseOver: handleMouseOver,
      onMouseOut: handleMouseOut,
      onKeyDown: handleKeyDown,
      onFocus: handleFocus,
      onBlur: handleBlur,
      title: '',
      ...mergeProps
    })), state.visible && /*#__PURE__*/_jsx(Layer, {
      children: /*#__PURE__*/_jsx("div", {
        ref: setPopperElement,
        style: styles.popper,
        ...attributes.popper,
        children: children(mergeProps => ({
          id,
          arrow: /*#__PURE__*/_jsx(TooltipArrow, {
            ref: node => setArrowElement(node),
            style: styles.arrow
          }),
          ...mergeProps
        }))
      })
    })]
  });
}
export { TooltipContainer };